module.exports = __webpack_public_path__ + "img/Dantam Fashion 04.abf8cd75.jpg";